export type LibraryVersion = { id:string; work_item_id:string; name:string; version:number };
export function libraryVersionFamily(article:LibraryVersion):string {
 return JSON.stringify([article.work_item_id,article.name]);
}
export function visibleLibraryVersions<T extends LibraryVersion>(articles:readonly T[],showPrevious:boolean,selectedId:string|null):T[] {
 if(showPrevious)return [...articles];
 const latest=new Map<string,T>();
 for(const article of articles){
  const key=libraryVersionFamily(article);
  const current=latest.get(key);
  if(!current || article.version>current.version)latest.set(key,article);
 }
 return articles.filter(article=>article.id===selectedId || latest.get(libraryVersionFamily(article))?.id===article.id);
}
export function libraryVersionsFor<T extends LibraryVersion>(articles:readonly T[],selected:LibraryVersion):T[] {
 const family=libraryVersionFamily(selected);
 return articles.filter(article=>libraryVersionFamily(article)===family)
  .sort((a,b)=>b.version-a.version || a.id.localeCompare(b.id));
}
